import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  OnInit,
  OnChanges,
  AfterViewInit,
  OnDestroy,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CheckboxTypeOneComponent } from '../../components/checkbox-type-one/checkbox-type-one.component';
import { CheckboxTypeThreeComponent } from '../../components/checkbox-type-three/checkbox-type-three.component';
import { OtpFieldComponent } from '../../components/otp-field/otp-field.component';
import { CheckboxWithTextComponent } from '../../components/checkbox-with-text/checkbox-with-text.component';
import { CheckboxTypeFourComponent } from '../../components/checkbox-type-four/checkbox-type-four.component';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { WorkflowService } from '../../../api/services/workflow.service';
import { environment } from '../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { FORM_ID } from '../../../helpers/form-id.enum';
import { ComponentsModule } from '../../components/components.module';
import { ActivatedRoute, Router } from '@angular/router';
import {
  catchError,
  forkJoin,
  map,
  Observable,
  of,
  Subject,
  takeUntil,
} from 'rxjs';
import { PhoneNumberComponent } from '../../components/phone-number/phone-number.component';
import { IntegrationCardsComponent } from '../../components/integration-cards/integration-cards.component';
import { DropdownWithSearchComponent } from '../../components/dropdown-with-search/dropdown-with-search.component';
import { AuthService } from '../../../api/services/auth.service';
import { DARK_COLORS } from '../../../helpers/constants/colors.constant';
import { NotificationHelperService } from '../../../helpers/notification-helper.service';

@Component({
  selector: 'app-form-render',
  templateUrl: './form-render.component.html',
  styleUrls: ['./form-render.component.css'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    DropdownWithSearchComponent,
  ],
})
export class FormRenderComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  endpoint = environment.api_endpoint;
  saveForm!: FormGroup;
  @Input() nodeId = '';
  @Input() recordID = '';
  @Input() workflowId = '';
  @Input() workflowData: any;
  @Input() isWorkflowData: any;
  @Input() isVideo: any;
  @Input() isBtnShow: any;
  @Input() isSavePrevious: any;
  @Input() isButtonShow: any;
  @Input() disableFields: any;
  @Input() showHeader = true;
  @Input() labelAbove: any;
  @Input() twoGridColumn: any;
  @Output() save = new EventEmitter<any>();
  @Output() formDataChange = new EventEmitter<any>();
  @ViewChild(CheckboxWithTextComponent)
  CheckboxWithTextComponent!: CheckboxWithTextComponent;
  @ViewChild(OtpFieldComponent) otpFieldComponent!: OtpFieldComponent;
  @ViewChild(CheckboxTypeFourComponent)
  CheckboxTypeFourComponent!: CheckboxTypeFourComponent;
  @ViewChild(CheckboxTypeOneComponent)
  CheckboxTypeOneComponent!: CheckboxTypeOneComponent;
  @ViewChild(CheckboxTypeThreeComponent)
  CheckboxTypeThreeComponent!: CheckboxTypeThreeComponent;
  @ViewChildren(PhoneNumberComponent)
  PhoneNumberComponent!: QueryList<PhoneNumberComponent>;
  @ViewChild(IntegrationCardsComponent)
  IntegrationCardsComponent!: IntegrationCardsComponent;
  @Output() saveWithNext = new EventEmitter<{}>();
  @Output() clickedOnPrevious = new EventEmitter<{}>();
  visibleFields: Record<string, boolean> = {};
  @Output() loadNodeWithSSE = new EventEmitter<{
    sseConfig: any;
    formId: string;
  }>();
  @Output() navigateNext = new EventEmitter<{
    apiResult: { status: number; data: any };
    node: any;
  }>();
  formFields: any;
  footerFields: any;
  formData: any;
  formPayload: any;
  isLoading = false;
  readonly emailSettingsFormId = FORM_ID.NOTIFICATIONS_INTEGRATIONS;
  updatedWorkflow: any;
  destroy$ = new Subject<void>();
  @Input() showOnboardingButton: any;
  childLoading = false;
  firstFocusFieldName: any;
  private taskMappingDependencyDestroy$ = new Subject<void>();
  private applicableTaskCountRequestId = 0;
  private applicableTaskCountRequestMap: { [key: string]: number } = {};
  applicableTaskCount = 0;
  applicableTaskLabel = '';
  applicableTaskSummary: {
    toDo: number;
    deployed: number;
    notApplicable: number;
  } = {
    toDo: 0,
    deployed: 0,
    notApplicable: 0,
  };

  private applicableTaskCountMap: {
    [key: string]: {
      toDo: number;
      deployed: number;
      notApplicable: number;
    };
  } = {};
  private taskMappingQuestions: { [fieldName: string]: string } = {};
  constructor(
    private formService: FormsServiceService,
    private workflowService: WorkflowService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private notificationHelper: NotificationHelperService,
    private cdr: ChangeDetectorRef,
  ) {}

  isSecondNodeOfLoginWorkflow(): boolean {
    const isLogin =
      this.workflowData?.name === 'User Login Workflow' ||
      this.workflowId === '68cf97738c07ccaa147d9b8b' ||
      this.workflowData?._id === '68cf97738c07ccaa147d9b8b' ||
      this.router.url.includes('/login') ||
      this.router.url.includes('68cf97738c07ccaa147d9b8b');

    if (!isLogin) {
      return false;
    }

    const currentNodeId =
      this.nodeId ||
      this.route.snapshot.paramMap.get('nodeId') ||
      this.formData?.formFields?.[0]?.formId;

    const nodes = this.workflowData?.nodes || [];

    if (nodes.length >= 2) {
      const currentIndex = nodes.findIndex((n: any) => n._id === currentNodeId);
      if (currentIndex === 1) {
        return true;
      }
      if (nodes[1]?._id && nodes[1]._id === currentNodeId) {
        return true;
      }
    }

    // Fallback: If form has OTP component/field in login workflow, it is the 2nd node
    const hasOtpField =
      this.formFields?.some(
        (f: any) =>
          f.fieldName === 'otp' ||
          f.componentId === 'otpInputField' ||
          f.componentId === 'otpField' ||
          f.componentId === 'otpHeaderField',
      ) ||
      this.formData?.formFields?.some(
        (f: any) =>
          f.fieldName === 'otp' ||
          f.componentId === 'otpInputField' ||
          f.componentId === 'otpField' ||
          f.componentId === 'otpHeaderField',
      );

    if (hasOtpField) {
      return true;
    }

    return false;
  }

  ngOnInit(): void {
    if (this.nodeId) {
      const recordId = this.recordID || '0';
      this.loadForm(this.nodeId, recordId);
    }
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const nodeId = params.get('nodeId');
      const recordId = params.get('recordId') || '0';

      if (nodeId) {
        this.loadForm(nodeId, recordId);
      }
      this.cdr.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const nodeIdChange = changes['nodeId'];
    const recordIDChange = changes['recordID'];
    const disableFieldsChange = changes['disableFields'];

    const hasNodeIdChanged =
      nodeIdChange &&
      nodeIdChange.currentValue !== nodeIdChange.previousValue &&
      !nodeIdChange.firstChange;
    const hasRecordIDChanged =
      recordIDChange &&
      recordIDChange.currentValue !== recordIDChange.previousValue &&
      !recordIDChange.firstChange;

    if (hasNodeIdChanged || hasRecordIDChanged) {
      if (this.nodeId) {
        const recordId = this.recordID || '0';
        this.loadForm(this.nodeId, recordId);
      }
    }

    if (disableFieldsChange && !disableFieldsChange.firstChange) {
      if (this.saveForm) {
        if (this.disableFields) {
          this.saveForm.disable();
        } else {
          this.saveForm.enable();
        }
      }
    }
  }

  ngAfterViewInit() {
    if (this.formData) {
      this.formDataChange.emit(this.formData);
    }
  }

  ngOnDestroy() {
    this.taskMappingDependencyDestroy$.next();
    this.taskMappingDependencyDestroy$.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Emit form values to parent when form is valid */
  async onSave(btn?: any): Promise<void> {
    // --- Validate button type ---
    const actionButtons = [
      'nextButton',
      'submitButton',
      'center-actionButton',
      'save',
    ];
    const isActionButton = actionButtons.includes(btn?.componentId);

    if (!isActionButton) {
      this.clickedOnPrevious.emit();
      return;
    }

    // --- Mark all fields as touched ---
    this.saveForm.markAllAsTouched();

    // --- Validate custom and form controls ---
    const isCustomValid = this.validateCustomComponents();
    if (!isCustomValid || !this.saveForm.valid) {
      return;
    }

    const isLoginOtp =
      this.isSecondNodeOfLoginWorkflow() ||
      !!this.saveForm?.get('otp')?.value ||
      this.formFields?.some(
        (f: any) =>
          f.fieldName === 'otp' ||
          f.componentId === 'otpInputField' ||
          f.componentId === 'otpField',
      ) ||
      this.formData?.formFields?.some(
        (f: any) =>
          f.fieldName === 'otp' ||
          f.componentId === 'otpInputField' ||
          f.componentId === 'otpField',
      );

    console.log(
      '[FormRender onSave] isLoginOtp:',
      isLoginOtp,
      'Notification.permission:',
      typeof Notification !== 'undefined' ? Notification.permission : 'n/a',
    );


    // --- Clean up form data ---
    const cleanedFormData = this.filterFormValue(this.saveForm, [
      'otpArray',
      'otpHeader',
    ]);

    // Email settings are saved straight to the form record
    if (this.nodeId === FORM_ID.NOTIFICATIONS_INTEGRATIONS) {
      // No card selected: fall back to the default email configuration
      const selected = cleanedFormData['emailConfiguration'];
      if (!Array.isArray(selected) ? !selected : selected.length === 0) {
        const defaultConfigId = '6a0568019f5f57bfd5b062dd';
        const configField = this.formFields?.find(
          (f: any) => f.fieldName === 'emailConfiguration',
        );
        const defaultOption = (configField?.options?.staticOptions || []).find(
          (o: any) => o?._id === defaultConfigId,
        );
        cleanedFormData['emailConfiguration'] = [defaultConfigId];
        cleanedFormData['emailConfigurationTags'] = [
          defaultOption?.name ?? 'emailConfiguration',
        ];
      }
      this.saveEmailSettings(cleanedFormData);
      return;
    }

    // --- Dependent field logic ---
    const dependentField = this.formFields.find(
      (f: any) => f.componentId === 'checkboxTypeFive',
    );
    const dependentValue = this.saveForm.get(
      dependentField?.fieldName || '',
    )?.value;

    const skipSubmitField = this.formFields.find(
      (f: any) =>
        ['noDataTypeOne', 'dataViewWithLoader', 'videoPlayer'].includes(
          f.componentId,
        ) &&
        (!f.fieldDependencies?.length || f.fieldDependencies == null) &&
        !(
          f.componentId === 'noDataTypeOne' &&
          (this.applicableTaskSummary?.deployed ||
            this.applicableTaskSummary?.toDo ||
            this.applicableTaskSummary?.notApplicable)
        ),
    );
    const hasTermsAcceptedField = this.formFields.some(
      (f: any) => f.fieldName === 'termsAccepted',
    );
    // --- Override fields.value with fields.defaultValue when both exist ----
    this.formFields?.forEach((field: any) => {
      if (
        field?.fieldName &&
        cleanedFormData[field.fieldName] !== undefined &&
        field?.defaultValue !== undefined &&
        field?.defaultValue !== null &&
        field?.defaultValue !== ''
      ) {
        cleanedFormData[field.fieldName] = field.defaultValue;
      }
    });
    // --- Set current date for termsAcceptedDate ---
    const termsAcceptedValue = this.saveForm.get('termsAccepted')?.value;

    if (termsAcceptedValue && !cleanedFormData['termsAcceptedDate']) {
      cleanedFormData['termsAcceptedDate'] = new Date().toISOString();
    }

    // --- Convert tag fields to { question, response } format (only if taskMapping is enabled) ---
    if (this.formData?.formCollection?.taskMapping) {
      this.formFields?.forEach((field: any) => {
        const tagsKey = field?.fieldName + 'Tags';
        if (field?.fieldName && cleanedFormData[tagsKey] !== undefined) {
          const fieldQuestion =
            this.taskMappingQuestions[field.fieldName] ||
            field.displayName ||
            field.helpText ||
            field.label ||
            field.fieldName ||
            '';
          const cleanedQuestion = fieldQuestion
            .trim()
            .replace(/^\d+\.\s*/, '')
            .replace(/[^a-zA-Z0-9)\]\s]+$/, '')
            .replace(/\s*[?.]$/, '');

          cleanedFormData[tagsKey] = {
            question: cleanedQuestion,
            response: cleanedFormData[tagsKey],
          };
        }
      });
    }

    // -------------------------------------
    // BEFORE using formPayload in conditions,
    // we must GENERATE it *early*.
    // -------------------------------------
    let formPayload: any = {};
    this.formPayload = {}; // reset if needed

    const nodes = this.workflowData?.nodes || [];
    const currentIndex = nodes.findIndex((n: any) => n._id === this.nodeId);
    const previousNode = currentIndex > 0 ? nodes[currentIndex - 1] : null;
    const previousData = previousNode?.previousData;

    const existingRecordId =
      (this.recordID && this.recordID !== '0' ? this.recordID : null) ||
      (this.formData?.formCollection?.recordId &&
      this.formData?.formCollection?.recordId !== '0'
        ? this.formData.formCollection.recordId
        : null);

    // --- Build formPayload early ---
    if (this.formData?.formCollection?.taskMapping) {
      cleanedFormData.toDoTasks = this.applicableTaskSummary.toDo;
      cleanedFormData.deployedTasks = this.applicableTaskSummary.deployed;
      cleanedFormData.notApplicableTasks =
        this.applicableTaskSummary.notApplicable;
    }
    if (this.workflowData?.layout?.leftColumnProperties?.showStepper) {
      formPayload = {
        formId: this.formData?.formFields?.[0]?.formId,
        ...(existingRecordId && { recordID: existingRecordId }),
        data: cleanedFormData,
      };
    } else if (this.isSavePrevious) {
      formPayload = { ...(previousData || {}), ...cleanedFormData };
    } else if (previousData) {
      formPayload = { ...previousData, ...cleanedFormData };
      if (previousData.email) {
        localStorage.setItem('email', previousData.email);
        const email = previousData.email;
        // this.posthog.identifyUser(email);
      }
    } else if (
      !this.formData?.apiIntegration?.useAPI &&
      this.formData?.formFields?.[0]?.formId !== '6a0492be707c82a431cd52b7' &&
      !this.isSavePrevious
    ) {
      formPayload = {
        formId: this.formData?.formFields?.[0]?.formId,
        ...(existingRecordId && { recordID: existingRecordId }),
        data: cleanedFormData,
      };
    } else {
      formPayload = {
        formId: this.formData?.formFields?.[0]?.formId,
        ...(existingRecordId && { recordID: existingRecordId }),
        data: cleanedFormData,
      };
    }

    this.formPayload = formPayload; // set globally

    // ========== DEPENDENCY HANDLING ==========

    // Case 1: Dependent field exists but not satisfied
    if (
      dependentField &&
      !dependentValue &&
      skipSubmitField &&
      !hasTermsAcceptedField
    ) {
      this.handleWorkflowOrSubmit(formPayload);
      return;
    }

    // Case 2: No dependencies
    if (skipSubmitField && !dependentField && !hasTermsAcceptedField) {
      this.handleWorkflowOrSubmit(formPayload);
      return;
    }

    // --- Handle Phone components ---
    if (this.PhoneNumberComponent?.length) {
      this.PhoneNumberComponent.forEach((child: any) => {
        const fieldName = child.fields.fieldName;
        cleanedFormData[fieldName] = child.getFullPhone(fieldName);
      });
    }

    // --- Emit Save ---
    this.save.emit(this.saveForm.value);

    // --- If API Integration is enabled ---
    if (
      this.formData?.apiIntegration?.useAPI ||
      this.formData?.formFields?.[0]?.formId === '6a0492be707c82a431cd52b7'
    ) {
      this.submitFormViaApi(formPayload, btn); // ←★★ Now ALWAYS receives formPayload
    } else {
      this.saveWithNext.emit();
      setTimeout(() => this.saveForm.reset(), 200);
    }
  }

  /** Saves the email settings form record with the current selection */
  private saveEmailSettings(data: any): void {
    const recordId =
      (this.recordID && this.recordID !== '0' ? this.recordID : null) ||
      this.formData?.formCollection?.recordId ||
      null;
    const payload = {
      formId: this.formData?.formFields?.[0]?.formId || this.nodeId,
      ...(recordId && recordId !== '0' && { recordID: recordId }),
      data,
    };

    this.isLoading = true;
    this.formService.submitFormData({ url: '', method: '' }, payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res?.success === false) {
          this.toaster.error(res?.message || 'Failed to save email settings.', 'Error', {
            messageClass: 'addMessage',
            titleClass: 'addCss',
          });
        } else {
          this.toaster.success('Email settings saved successfully.', 'Success', {
            messageClass: 'addMessage',
            titleClass: 'addCss',
          });
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoading = false;
        this.toaster.error(
          err?.error?.message || 'Failed to save email settings.',
          'Error',
          { messageClass: 'addMessage', titleClass: 'addCss' },
        );
        this.cdr.detectChanges();
      },
    });
  }

  /**
   * Saves the workflow if present, otherwise submits the form.
   */
  handleWorkflowOrSubmit(formPayload: any) {
    if (this.workflowData) {
      this.saveWorkflow();
    } else {
      this.submitFormViaApi(formPayload, { componentId: 'save' });
    }
  }

  /**
   * Prepares workflow data and triggers workflow instance update.
   */
  saveWorkflow() {
    this.onNodeCompleted(this.nodeId);
    if (this.workflowData?.name != 'User Login Workflow') {
      this.updatedWorkflow = {
        ...this.workflowData,
        startNodeId: this.nodeId,
        nodes: [...this.workflowData?.nodes],
        stepperItems: this.workflowData?.stepperItems,
      };
    } else {
      this.updatedWorkflow = {
        ...this.workflowData,
        nodes: [...this.workflowData?.nodes],
        stepperItems: this.workflowData?.stepperItems,
      };
    }
    const workflowId = this.workflowData?._id || this.workflowId;
    if (!workflowId) {
      return;
    }
    const apiUrl = `/api/v1/workflow/instances/${workflowId}`;
    this.updateWorkflow(apiUrl, this.updatedWorkflow, true);
  }

  /**
   * Updates the workflow instance and resets the form on success.
   */
  updateWorkflow(apiUrl: any, updatedWorkflow: any, isLoading: boolean) {
    this.workflowService
      .updateWorkflowInstance(apiUrl, updatedWorkflow)
      .subscribe({
        next: (resp) => {
          this.saveWithNext.emit();
          setTimeout(() => this.saveForm.reset(), 200);
          if (isLoading == true) {
            this.isLoading = false;
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.cdr.detectChanges();
        },
      });
  }

  /** Utility to exclude internal fields  */
  filterFormValue(form: FormGroup, excludeKeys: string[] = []): any {
    return Object.keys(form.value)
      .filter((key) => !excludeKeys.includes(key))
      .reduce(
        (acc: Record<string, any>, key) => {
          acc[key] = form.value[key];
          return acc;
        },
        {} as Record<string, any>,
      );
  }

  /** Validate component selection on click of button */
  validateCustomComponents(): boolean {
    let isValid = true;

    if (this.CheckboxTypeFourComponent) {
      isValid = this.CheckboxTypeFourComponent.validateSelection() && isValid;
    }
    if (this.CheckboxTypeOneComponent) {
      isValid = this.CheckboxTypeOneComponent.validateSelection() && isValid;
    }
    if (this.CheckboxTypeThreeComponent) {
      isValid = this.CheckboxTypeThreeComponent.validateSelection() && isValid;
    }
    if (this.CheckboxWithTextComponent) {
      isValid = this.CheckboxWithTextComponent.onCheckboxChange() && isValid;
    }

    if (this.otpFieldComponent) {
      this.otpFieldComponent.validateOtp();
      if (this.otpFieldComponent.errorMessage) {
        isValid = false;
      }
    }
    return isValid;
  }

  /** Submit request payload in the api with updated workflow data*/
  submitFormViaApi(payload: any, btn?: any): void {
    this.isLoading = true;
    const api_endpoint = this.endpoint;
    let url = this.formData?.apiIntegration?.apiUrl
      ? this.formData?.apiIntegration?.apiUrl
      : '';
    const replacements = {
      api_endpoint: api_endpoint,
    };
    const method = this.formData?.apiIntegration?.apiMethod
      ? this.formData?.apiIntegration?.apiMethod
      : '';
    url = this.formService.replaceTemplateTokens(url, replacements);
    this.formService
      .submitFormData({ url: url, method: method }, payload)
      .subscribe({
        next: async (res) => {
          if (res.success) {
            if (this.formData?.apiIntegration?.apiSuccessMessage != '') {
              this.toaster.success(
                this.formData?.apiIntegration?.apiSuccessMessage,
                'Success',
                {
                  messageClass: 'addMessage',
                  titleClass: 'addCss',
                },
              );
              if (btn.componentId == 'save') {
                const recordID = this.recordID || res.data._id;

                this.router.navigate(['/onboarding', this.nodeId, recordID]);
                this.loadForm(this.nodeId, recordID);
              }
              this.isLoading = false;
            } else {
              this.toaster.success(res.message, 'Success', {
                messageClass: 'addMessage',
                titleClass: 'addCss',
              });
              this.isLoading = false;
            }
          }
          const authToken =
            res?.data?.token ||
            res?.data?.accessToken ||
            res?.token ||
            res?.accessToken ||
            res?.data?.jwt ||
            res?.jwt ||
            localStorage.getItem('accessToken') ||
            localStorage.getItem('token') ||
            '';

          const refreshToken =
            res?.data?.refreshToken ||
            res?.refreshToken ||
            localStorage.getItem('refreshToken') ||
            '';

          if (authToken) {
            localStorage.setItem('accessToken', authToken);
            localStorage.setItem('token', authToken);
          }
          if (refreshToken) {
            localStorage.setItem('refreshToken', refreshToken);
          }

          const InsertedID =
            res?.data?._id ||
            res?.data?.userId ||
            res?.data?.id ||
            res?.data?.user?._id ||
            res?.data?.user?.id ||
            res?._id ||
            res?.userId ||
            localStorage.getItem('userId') ||
            '';
          if (InsertedID) {
            localStorage.setItem('userId', InsertedID);
          }

          if (res?.data?.user) {
            localStorage.setItem('user', JSON.stringify(res.data.user));
          } else if (res?.data) {
            localStorage.setItem('user', JSON.stringify(res.data));
          }

          const isLoginOtp =
            this.isSecondNodeOfLoginWorkflow() ||
            !!this.saveForm?.get('otp')?.value ||
            this.formFields?.some(
              (f: any) =>
                f.fieldName === 'otp' ||
                f.componentId === 'otpInputField' ||
                f.componentId === 'otpField',
            ) ||
            this.formData?.formFields?.some(
              (f: any) =>
                f.fieldName === 'otp' ||
                f.componentId === 'otpInputField' ||
                f.componentId === 'otpField',
            );

          console.log(
            '[FormRender submitFormViaApi] isLoginOtp:',
            isLoginOtp,
            'authToken present:',
            !!authToken,
            'InsertedID:',
            InsertedID,
          );

          if (isLoginOtp) {
            if (InsertedID) {
              localStorage.setItem('userId', InsertedID);
            }
            if (authToken) {
              localStorage.setItem('accessToken', authToken);
              localStorage.setItem('token', authToken);
            }

            // Set login flag so push notification prompt can be triggered on landing
            sessionStorage.setItem('just_logged_in', 'true');
            localStorage.setItem('just_logged_in', 'true');

            this.router
              .navigate(['/eciso/executive-dashboard'])
              .then((navigated) => {
                if (!navigated) {
                  window.location.href = '/eciso/executive-dashboard';
                }
              });
            this.isLoading = false;
            this.cdr.detectChanges();
            return;
          }
          if (res?.data?.onPM == true || res?.data?.onPM == false) {
            const apiResult = {
              status: res.status || 200,
              data: res.data || {},
            };
            this.navigateNext.emit({ apiResult, node: this.nodeId });
          }
          const node = this.workflowData?.nodes?.find(
            (n: any) => n._id === this.nodeId,
          );
          if (node) {
            if (!node.recordId || node.recordId == '' || node.recordId == '0') {
              node.recordId = InsertedID;
            }
          }
          if (
            !this.workflowData?.layout?.leftColumnProperties?.showStepper &&
            this.isSavePrevious
          ) {
            node.previousData = this.saveForm.value;
          }

          this.onNodeCompleted(this.nodeId);
          if (this.workflowData?.name != 'User Login Workflow') {
            this.updatedWorkflow = {
              ...this.workflowData,
              startNodeId: this.nodeId,
              nodes: [...this.workflowData?.nodes],
              stepperItems: this.workflowData?.stepperItems,
            };
          } else {
            this.updatedWorkflow = {
              ...this.workflowData,
              nodes: [...this.workflowData.nodes],
              stepperItems: this.workflowData.stepperItems,
            };
          }
          const workflowId = this.workflowData?._id || this.workflowId;
          if (!workflowId) {
            return;
          }
          const apiUrl = `/api/v1/workflow/instances/${workflowId}`;
          this.updateWorkflow(apiUrl, this.updatedWorkflow, false);
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          if (this.formData?.apiIntegration?.apiErrorMessage != '') {
            this.toaster.error(
              this.formData?.apiIntegration?.apiErrorMessage,
              'Error',
              {
                messageClass: 'addMessage',
                titleClass: 'addCss',
              },
            );
          } else {
            this.toaster.error(err.error.message, 'Error', {
              messageClass: 'addMessage',
              titleClass: 'addCss',
            });
          }
          this.cdr.detectChanges();
        },
      });
  }

  /** Update stepper active,current and completed class on click of button */
  onNodeCompleted(nodeId: string) {
    this.workflowService.updateStepperState(this.workflowData, nodeId);
  }

  /** Get stepper child by the nodeId */
  getStepperChildIdByNodeId(nodeId: string): string | null {
    const node = this.workflowData.nodes.find((n: any) => n._id === nodeId);
    return node?.stepperChildId || null;
  }

  /**
   * Updates field visibility and dynamically applies or clears validators
   * based on field dependency rules.
   */
  onVisibilityChange(updatedVisibility: {
    visibilityMap: Record<string, boolean>;
    toggleField: string;
    skipTaskMappingDependency?: boolean;
  }) {
    this.visibleFields = {
      ...this.visibleFields,
      ...updatedVisibility.visibilityMap,
    };

    // Find the toggled field definition
    const toggledFieldDef = this.formData?.formFields?.find(
      (f: any) => f.fieldName === updatedVisibility.toggleField,
    );

    // Get dependent fields that are required
    const dependentRequiredFields = new Set<string>();
    if (toggledFieldDef?.fieldDependencies?.length) {
      toggledFieldDef.fieldDependencies.forEach((dep: any) => {
        dep.condition?.forEach((cond: any) => {
          cond.actions?.forEach((action: any) => {
            if (action.actionType === 'isRequired' && action.value === true) {
              dependentRequiredFields.add(action.targetField);
            }
          });
        });
      });
    }

    // Apply changes
    Object.keys(updatedVisibility.visibilityMap).forEach((fieldKey) => {
      const control = this.saveForm.get(fieldKey);
      const isVisible = updatedVisibility.visibilityMap[fieldKey];
      if (!control) return;

      if (isVisible) {
        if (dependentRequiredFields.has(fieldKey)) {
          control.setValidators([Validators.required]);

          // Show error instantly for required but empty fields
          if (!control.value) {
            control.markAsTouched({ onlySelf: true });
          }
        } else {
          // No isRequired action → no required validator
          control.clearValidators();
        }
      } else {
        control.clearValidators();
        // control.reset(null, { emitEvent: false });
        control.markAsUntouched();
        control.markAsPristine();
        delete this.applicableTaskCountMap[fieldKey];
      }

      control.updateValueAndValidity({ onlySelf: true });
    });

    if (!updatedVisibility.skipTaskMappingDependency) {
      this.handleTaskMappingDependency({
        fieldName: updatedVisibility.toggleField,
        tags: this.getTagsForField(updatedVisibility.toggleField) || [],
        selectedQuestion: '',
      });
    }
    this.cdr.detectChanges();
  }

  private getTagsForField(fieldName: string): string[] {
    return this.saveForm.get(fieldName + 'Tags')?.value || [];
  }

  /** Function to load the form with the formId */
  loadForm(formId: any, recordId?: any) {
    this.resetapplicableTaskCount();
    this.formService.loadFormData(formId, recordId).subscribe({
      next: (data) => {
        this.resetapplicableTaskCount();
        this.formData = data.data;
        this.formFields = this.formData?.formFields;
        // Add additional fields for Integration form
        if (formId === '6919b7bec2ed5bad29a60d51') {
          this.formFields.push(
            {
              formId: '6919b7bec2ed5bad29a60d51',
              version: 0,
              fieldName: 'cloudInfrastructureDetails',
              displayName: 'Cloud Infrastructure',
              fieldType: 'singleSelect',
              isRequired: false,
              multiselect: false,
              placeholder: 'Enter cloud infrastructure tool details here...',
              helpText:
                'Provide any additional information regarding your cloud infrastructure tool.',
              componentId: 'integrationCards',
              tags: [],
              options: {
                isStatic: false,
                staticOptions: [],
                source: {
                  type: '',
                  formID: '6919b404c2ed5bad29a60d47',
                  apiUrl:
                    '{{api_endpoint}}/api/v1/form/data/list/{{formID}}?category=Cloud Infrastructure',
                  method: 'GET',
                  headers: {
                    Authorization: 'Bearer {{token}}',
                    'Content-Type': 'application/json',
                  },
                  parameters: {
                    language: 'en',
                    region: 'IN',
                  },
                  responseMapping: [],
                  body: {
                    iamSync: false,
                  },
                },
              },
              validationRules: [],
              properties: {},
              uiOptions: {
                className: '',
                labelClass: '',
                image: '',
                text: '',
                subText: '',
                style: null,
              },
              fieldDependencies: null,
              value: null,
              defaultValue: null,
              domain: null,
              intent: '',
              promptText: '',
              promptTemplate: '',
              deletedFlag: false,
              deletedDate: '0001-01-01T00:00:00Z',
            },
            {
              formId: '6919b7bec2ed5bad29a60d51',
              version: 0,
              fieldName: 'emailConfigurationDetails',
              displayName: 'Email Configuration',
              fieldType: 'singleSelect',
              isRequired: false,
              multiselect: false,
              placeholder: 'Enter email configuration details here...',
              helpText:
                'Provide any additional information regarding your email configurations.',
              componentId: 'integrationCards',
              tags: [],
              options: {
                isStatic: false,
                staticOptions: [],
                source: {
                  type: '',
                  formID: '6919b404c2ed5bad29a60d47',
                  apiUrl:
                    '{{api_endpoint}}/api/v1/form/data/list/{{formID}}?category=Email Configuration',
                  method: 'GET',
                  headers: {
                    Authorization: 'Bearer {{token}}',
                    'Content-Type': 'application/json',
                  },
                  parameters: {
                    language: 'en',
                    region: 'IN',
                  },
                  responseMapping: [],
                  body: {
                    iamSync: false,
                  },
                },
              },
              validationRules: [],
              properties: {},
              uiOptions: {
                className: '',
                labelClass: '',
                image: '',
                text: '',
                subText: '',
                style: null,
              },
              fieldDependencies: null,
              value: null,
              defaultValue: null,
              domain: null,
              intent: '',
              promptText: '',
              promptTemplate: '',
              deletedFlag: false,
              deletedDate: '0001-01-01T00:00:00Z',
            },
          );
        }
        this.footerFields = this.formData?.footerFields;
        this.formDataChange.emit(this.formData);
        this.buildForm();
        // 🔹 Check if SSE config is present
        if (this.formData?.sseConfig) {
          this.handleAutoExecute(
            this.formData.sseConfig,
            this.formData?.formFields[0]?.formId,
          );
        }
        this.setFirstFocusField();
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.cdr.detectChanges();
      },
    });
  }

  private resetapplicableTaskCount() {
    this.applicableTaskCountRequestId++;
    this.applicableTaskCountMap = {};
    this.applicableTaskCountRequestMap = {};
    this.applicableTaskCount = 0;
    this.applicableTaskSummary = {
      toDo: 0,
      deployed: 0,
      notApplicable: 0,
    };
  }

  /** Pass autoExecute/SSE config to workflowRenderer */
  handleAutoExecute(sseConfig: any, formId: any) {
    const apiEndpoint = environment.api_endpoint;
    const accessToken = this.auth.token;
    const finalConfig = {
      ...sseConfig,
      url: sseConfig.url
        .replace('{{api_endpoint}}', apiEndpoint)
        .replace('{{authToken}}', accessToken),
    };
    this.loadNodeWithSSE.emit({ sseConfig: finalConfig, formId: formId });
  }

  /**
   * Dynamically builds the reactive form with controls, validators,
   * visibility rules, and special handling for OTP and tag-based fields.
   */
  buildForm() {
    const group: Record<string, any> = {};
    const dynamicallyControlledFields = new Set<string>();
    const emailFromQuery = this.route.snapshot.queryParamMap.get('email') || '';
    // Step 1: Identify dynamically controlled fields
    this.formFields?.forEach((field: any) => {
      if (Array.isArray(field.fieldDependencies)) {
        field.fieldDependencies.forEach((dependency: any) => {
          if (dependency.trigger === 'onValueChange') {
            const conditionBlocks = Array.isArray(dependency.condition)
              ? dependency.condition
              : Array.isArray(dependency.conditions)
                ? dependency.conditions
                : [];

            conditionBlocks.forEach((cond: any) => {
              if (Array.isArray(cond.actions)) {
                cond.actions.forEach((action: any) => {
                  if (action.targetField) {
                    dynamicallyControlledFields.add(action.targetField);
                  }
                });
              }
            });
          }
        });
      }
    });

    // Step 2: Create FormControls
    this.formFields?.forEach((field: any) => {
      this.visibleFields[field.fieldName] = !dynamicallyControlledFields.has(
        field.fieldName,
      );

      if (
        ['label', 'button', 'grid', 'video', 'noData'].includes(field.fieldType)
      ) {
        return; // skip non-input fields
      }

      const validators = [];
      const validationRules = Array.isArray(field.validationRules)
        ? field.validationRules
        : [];

      const isRequired =
        field.isRequired &&
        field.fieldName !== 'loginWith' &&
        field.componentId !== 'loginCards' &&
        !dynamicallyControlledFields.has(field.fieldName);

      if (isRequired) {
        validators.push(Validators.required);
      }

      const minLength = validationRules.find(
        (v: any) => v.type === 'minLength',
      );
      if (minLength) {
        if (isRequired) {
          validators.push(Validators.minLength(minLength.value));
        } else {
          validators.push((control: AbstractControl) => {
            const val = control.value;
            if (
              !val ||
              (Array.isArray(val) && val.length === 0) ||
              val === ''
            ) {
              return null;
            }
            return Validators.minLength(minLength.value)(control);
          });
        }
      }

      const maxLength = validationRules.find(
        (v: any) => v.type === 'maxLength',
      );
      if (
        maxLength &&
        field.fieldType !== 'multiSelect' &&
        !field.multiselect
      ) {
        validators.push(Validators.maxLength(maxLength.value));
      }

      const minValue = validationRules.find((v: any) => v.type === 'min');
      if (minValue) validators.push(Validators.min(minValue.value));

      const maxValue = validationRules.find((v: any) => v.type === 'max');
      if (maxValue) validators.push(Validators.max(maxValue.value));

      const regex = validationRules.find(
        (v: any) => v.type?.toLowerCase() === 'regex',
      );
      if (regex?.value) {
        const flags = field.fieldType === 'textarea' ? 's' : '';
        validators.push(Validators.pattern(new RegExp(regex.value, flags)));
      }

      if (
        field.fieldType === 'email' ||
        validationRules.some((v: any) => v.type === 'email')
      ) {
        validators.push(Validators.email);
      }

      // Step 3: OTP fields
      if (field.fieldName === 'otp') {
        const otpLength = field.properties?.otpLength || 6;
        const otpControls = Array.from(
          { length: otpLength },
          () =>
            new FormControl('', [
              Validators.required,
              Validators.pattern('[0-9]'),
            ]),
        );
        group['otpArray'] = this.fb.array(otpControls);
        group['otp'] = new FormControl('');
      } else {
        // Step 4: Regular fields
        const existingValue = this.saveForm?.get(field.fieldName)?.value;

        let defaultValue = existingValue ?? field.value ?? '';
        if (field.fieldType === 'email' && emailFromQuery) {
          defaultValue = emailFromQuery;
        }
        group[field.fieldName] = new FormControl(defaultValue, validators);

        // Step 5: Tags control for checkboxes / toggles / multi-select
        if (
          ![
            'label',
            'button',
            'grid',
            'video',
            'noData',
            'search',
            'email',
            'otpHeader',
          ].includes(field.fieldType)
        ) {
          const existingTags =
            this.saveForm?.get(`${field.fieldName}Tags`)?.value ?? [];

          // For checkboxes/toggles: set tags based on initial value
          let initialTags = existingTags;
          if (
            (field.fieldType === 'checkbox' ||
              field.fieldType === 'multiSelect') &&
            Array.isArray(field.value)
          ) {
            initialTags = field.value
              .map((id: any) => {
                const item = field.options?.staticOptions?.find(
                  (opt: any) => opt._id === id || opt.cloudId === id,
                );
                return item?.name;
              })
              .filter(
                (name: any) =>
                  name !== undefined && name !== null && name !== '',
              );
          } else if (
            field.fieldType === 'toggle' &&
            typeof field.value === 'boolean'
          ) {
            initialTags =
              field.componentId === 'checkboxTypeFive'
                ? field.value
                  ? [true]
                  : []
                : field.value
                  ? [field.displayName]
                  : [];
          }

          group[`${field.fieldName}Tags`] = new FormControl(initialTags);
        }
      }
    });
    this.saveForm = new FormGroup(group);
    this.registerCustomFieldDependencyWatchers();
    if (this.disableFields) {
      this.saveForm.disable();
    }
    this.visibleFields['noDataField'] = true;
    this.resetTaskMappingDependencyWatchers();
    this.registerTaskMappingDependencyWatchers();
    this.initializeTaskMappingDependencies();
  }

  initializeTaskMappingDependencies() {
    this.handleTaskMappingDependency();
  }

  resetTaskMappingDependencyWatchers() {
    this.taskMappingDependencyDestroy$.next();
    this.taskMappingDependencyDestroy$.complete();
    this.taskMappingDependencyDestroy$ = new Subject<void>();
  }

  registerTaskMappingDependencyWatchers() {
    this.formFields?.forEach((field: any) => {
      const hasTaskMappingDependency = field?.fieldDependencies?.some(
        (dependency: any) => dependency?.trigger === 'isTaskMapped',
      );

      if (!hasTaskMappingDependency) {
        return;
      }

      this.saveForm
        ?.get(field.fieldName)
        ?.valueChanges.pipe(
          takeUntil(this.destroy$),
          takeUntil(this.taskMappingDependencyDestroy$),
        )
        .subscribe(() => {
          this.handleTaskMappingDependency(field.fieldName);
          this.cdr.detectChanges();
        });
    });
  }

  handleTaskMappingDependency(
    event?:
      | string
      | {
          fieldName: string;
          tags: any[];
          selectedQuestion: any;
        },
  ) {
    const taskMappingEvent = this.normalizeTaskMappingEvent(event);

    const toggleField = taskMappingEvent?.fieldName;

    const selectedTags = taskMappingEvent?.tags || [];

    const selectedQuestion = taskMappingEvent?.selectedQuestion;

    if (toggleField && selectedQuestion) {
      this.taskMappingQuestions[toggleField] = selectedQuestion;
    }

    const selectedFieldValues =
      this.getTaskMappingFieldSelectedValues(toggleField);

    // =========================================================
    // RESET WHEN TASK MAPPING NOT AVAILABLE
    // =========================================================

    if (!this.formData?.formCollection?.taskMapping) {
      this.applicableTaskSummary = {
        toDo: 0,
        deployed: 0,
        notApplicable: 0,
      };
      this.cdr.detectChanges();

      return;
    }

    // =========================================================
    // RESET WHEN TAGS REMOVED
    // =========================================================

    if (
      toggleField &&
      selectedTags.length === 0 &&
      selectedFieldValues.length === 0
    ) {
      this.applicableTaskCountRequestMap[toggleField] =
        (this.applicableTaskCountRequestMap[toggleField] || 0) + 1;

      delete this.applicableTaskCountMap[toggleField];

      this.applicableTaskSummary = this.getTotalapplicableTaskCountFromMap();
      this.cdr.detectChanges();

      return;
    }

    // =========================================================
    // BUILD CONFIGS
    // =========================================================

    const countConfigs =
      this.formData?.formFields?.reduce((configs: any[], field: any) => {
        const taskMappedDependency = field?.fieldDependencies?.find(
          (dependency: any) => dependency?.trigger === 'isTaskMapped',
        );

        if (
          !taskMappedDependency ||
          this.visibleFields[field.fieldName] === false
        ) {
          return configs;
        }

        const conditionBlocks: any[] = Array.isArray(
          taskMappedDependency.condition,
        )
          ? taskMappedDependency.condition
          : Array.isArray(taskMappedDependency.conditions)
            ? taskMappedDependency.conditions
            : taskMappedDependency.condition
              ? [taskMappedDependency.condition]
              : taskMappedDependency.conditions
                ? [taskMappedDependency.conditions]
                : [];

        const matchedCondition =
          conditionBlocks.find((conditionBlock: any) =>
            this.isTaskMappingConditionMatched(
              conditionBlock?.conditions ?? conditionBlock?.condition,
            ),
          ) || conditionBlocks[0];

        const matchedConditions = this.normalizeConditionList(
          matchedCondition?.conditions ?? matchedCondition?.condition,
        );

        // =========================================================
        // SKIP UNRELATED FIELD
        // =========================================================

        if (
          toggleField &&
          !this.taskMappingConditionsReferenceField(
            matchedConditions,
            toggleField,
          )
        ) {
          return configs;
        }

        const countAction = matchedCondition?.actions?.find(
          (action: any) =>
            action?.targetField === 'deployedTaskCount' &&
            action?.actionType === 'count',
        );

        const extractedValue = this.mapConfigValues(countAction?.value);

        if (!extractedValue?.formID || !extractedValue?.apiUrl) {
          return configs;
        }

        const triggerField =
          toggleField ||
          matchedConditions.find(
            (condition: any) => condition?.type === 'field' && condition?.value,
          )?.value;

        let cleanedQuestion =
          typeof selectedQuestion === 'string'
            ? selectedQuestion.trim().replace(/\s*[?.]$/, '')
            : '';

        if (!cleanedQuestion && triggerField) {
          const triggerFieldDef = this.formFields?.find(
            (f: any) => f.fieldName === triggerField,
          );
          if (triggerFieldDef) {
            const fieldQuestion =
              triggerFieldDef.displayName ||
              triggerFieldDef.helpText ||
              triggerFieldDef.label ||
              triggerFieldDef.fieldName ||
              '';
            cleanedQuestion = fieldQuestion
              .trim()
              .replace(/^\d+\.\s*/, '')
              .replace(/[^a-zA-Z0-9)\]\s]+$/, '')
              .replace(/\s*[?.]$/, '');
          }
        }

        if (!cleanedQuestion) {
          const fieldQuestion =
            field?.displayName ||
            field?.helpText ||
            field?.label ||
            field?.fieldName ||
            '';
          cleanedQuestion = fieldQuestion
            .trim()
            .replace(/^\d+\.\s*/, '')
            .replace(/[^a-zA-Z0-9)\]\s]+$/, '')
            .replace(/\s*[?.]$/, '');
        }

        const selectedIds = this.getTaskMappingResponseValues(
          matchedConditions,
          taskMappingEvent,
        );

        // =========================================================
        // SKIP INVALID CONFIGS
        // =========================================================

        if (!cleanedQuestion && (!selectedIds || selectedIds.length === 0)) {
          return configs;
        }

        configs.push({
          ...extractedValue,
          operator: matchedCondition?.operator,
          conditions: matchedConditions,
          responseValues: selectedTags,
          tags: selectedTags,
          triggerField,
          selectedQuestion: cleanedQuestion,
        });

        return configs;
      }, []) || [];

    // =========================================================
    // NO CONFIGS FOUND
    // =========================================================

    if (!countConfigs.length) {
      if (toggleField) {
        this.applicableTaskCountRequestMap[toggleField] =
          (this.applicableTaskCountRequestMap[toggleField] || 0) + 1;

        delete this.applicableTaskCountMap[toggleField];
      } else {
        this.applicableTaskCountRequestId++;
      }

      this.applicableTaskSummary = this.getTotalapplicableTaskCountFromMap();
      this.cdr.detectChanges();

      return;
    }

    // =========================================================
    // LOAD COUNTS
    // =========================================================

    const requestId = toggleField
      ? (this.applicableTaskCountRequestMap[toggleField] =
          (this.applicableTaskCountRequestMap[toggleField] || 0) + 1)
      : ++this.applicableTaskCountRequestId;

    this.loadTotalapplicableTaskCount(countConfigs).subscribe((res: any) => {
      // =========================================================
      // IGNORE OLD REQUESTS
      // =========================================================

      const summary = {
        toDo: res?.toDo || 0,
        deployed: res?.deployed || 0,
        notApplicable: res?.notApplicable || 0,
      };

      // =========================================================
      // FIELD SPECIFIC UPDATE
      // =========================================================

      if (toggleField) {
        if (requestId !== this.applicableTaskCountRequestMap[toggleField]) {
          return;
        }

        this.applicableTaskCountMap[toggleField] = summary;

        this.applicableTaskSummary = this.getTotalapplicableTaskCountFromMap();
        this.cdr.detectChanges();

        return;
      }

      // =========================================================
      // FULL RESET
      // =========================================================

      if (requestId !== this.applicableTaskCountRequestId) {
        return;
      }

      this.applicableTaskCountMap = {};

      this.applicableTaskSummary = summary;
      this.cdr.detectChanges();
    });
  }
  isTaskMappingConditionMatched(conditions: any[] = []) {
    if (!Array.isArray(conditions) || conditions.length === 0) {
      return false;
    }

    return conditions.every((condition: any) => {
      if (condition?.type !== 'field' || condition.value == null) {
        return false;
      }

      const fieldValue = this.saveForm?.get(condition.value)?.value;
      const hasValue = Array.isArray(fieldValue)
        ? fieldValue.length > 0
        : fieldValue !== null && fieldValue !== undefined && fieldValue !== '';

      if (condition?.triggerFunction === true) {
        return hasValue;
      }

      return hasValue;
    });
  }

  private getTotalapplicableTaskCountFromMap(): {
    toDo: number;
    deployed: number;
    notApplicable: number;
  } {
    return Object.keys(this.applicableTaskCountMap).reduce(
      (acc, key) => {
        if (this.visibleFields[key] !== false) {
          const count = this.applicableTaskCountMap[key];
          acc.toDo += count?.toDo || 0;
          acc.deployed += count?.deployed || 0;
          acc.notApplicable += count?.notApplicable || 0;
        }
        return acc;
      },
      {
        toDo: 0,
        deployed: 0,
        notApplicable: 0,
      },
    );
  }

  // =========================================================
  // LOAD SINGLE TASK COUNT
  // =========================================================

  loadapplicableTaskCount(config: any): Observable<any> {
    const fieldName = config?.triggerField;

    const selectedIds = Array.isArray(config?.responseValues)
      ? config.responseValues
      : this.getTaskMappingSelectedValues(config?.conditions);

    const uniqueSelectedIds = Array.from(new Set(selectedIds));

    const extractedConfig = this.mapConfigValues(config?.value || []);

    const method = extractedConfig.method || config.method || 'GET';

    const formID = extractedConfig.formID || config.formID;

    const apiUrlTemplate = '{{api_endpoint}}/api/v1/form/data/list/{{formID}}';

    let selectedQuestion =
      typeof config?.selectedQuestion === 'string'
        ? config.selectedQuestion.trim()
        : '';

    selectedQuestion = selectedQuestion.replace(/\s*[?.]$/, '');

    // =========================================================
    // AND CASE
    // =========================================================

    if (config?.operator === 'AND' && uniqueSelectedIds.length > 0) {
      return forkJoin(
        uniqueSelectedIds.map((selectedId) => {
          const responseValue = selectedId?.toString() || '';

          const replacements = {
            api_endpoint: this.endpoint,
            formID: formID,
            selectedID: responseValue,
          };

          let url = this.formService.replaceTemplateTokens(
            apiUrlTemplate,
            replacements,
          );

          if (!responseValue) {
            return of({
              toDo: 0,
              deployed: 0,
              notApplicable: 0,
            });
          }

          const isSoftwareDevType = fieldName === 'softwareDevelopmentType';

          if (isSoftwareDevType && selectedQuestion && responseValue) {
            url += `?question=${encodeURIComponent(
              selectedQuestion,
            )}&query=${encodeURIComponent(responseValue)}`;
          } else if (selectedQuestion && responseValue) {
            url += `?question=${encodeURIComponent(
              selectedQuestion,
            )}&response=${encodeURIComponent(responseValue)}`;
          } else {
            url += `?query=${encodeURIComponent(responseValue)}`;
          }

          return this.formService
            .loadData(
              method,
              url,
              { 'Content-Type': 'application/json' },
              {},
              30,
            )
            .pipe(
              map((res: any) => {
                const records = res?.data?.records || [];

                const summary = records.reduce(
                  (
                    acc: {
                      toDo: number;
                      deployed: number;
                      notApplicable: number;
                    },
                    record: any,
                  ) => {
                    acc.toDo += (record?.toDo || []).length;
                    acc.deployed += (record?.deployed || []).length;
                    acc.notApplicable += (record?.notApplicable || []).length;

                    return acc;
                  },
                  {
                    toDo: 0,
                    deployed: 0,
                    notApplicable: 0,
                  },
                );

                return summary;
              }),
              catchError(() =>
                of({
                  toDo: 0,
                  deployed: 0,
                  notApplicable: 0,
                }),
              ),
            );
        }),
      ).pipe(
        map((results: any[]) => {
          return results.reduce(
            (acc, item) => {
              acc.toDo += item?.toDo || 0;
              acc.deployed += item?.deployed || 0;
              acc.notApplicable += item?.notApplicable || 0;

              return acc;
            },
            {
              toDo: 0,
              deployed: 0,
              notApplicable: 0,
            },
          );
        }),
      );
    }

    // =========================================================
    // SINGLE CALL CASE
    // =========================================================

    const selectedId = uniqueSelectedIds[0]?.toString() || '';

    if (!selectedId) {
      return of({
        toDo: 0,
        deployed: 0,
        notApplicable: 0,
      });
    }

    const replacements = {
      api_endpoint: this.endpoint,
      formID: formID,
      selectedID: selectedId,
    };

    let url = this.formService.replaceTemplateTokens(
      apiUrlTemplate,
      replacements,
    );

    const isSoftwareDevType = fieldName === 'softwareDevelopmentType';

    if (isSoftwareDevType && selectedQuestion && selectedId) {
      url += `?question=${encodeURIComponent(
        selectedQuestion,
      )}&query=${encodeURIComponent(selectedId)}`;
    } else if (selectedQuestion && selectedId) {
      url += `?question=${encodeURIComponent(
        selectedQuestion,
      )}&response=${encodeURIComponent(selectedId)}`;
    } else {
      url += `?query=${encodeURIComponent(selectedId)}`;
    }

    return this.formService
      .loadData(method, url, { 'Content-Type': 'application/json' }, {}, 30)
      .pipe(
        map((res: any) => {
          const record = res?.data?.records?.[0] || {};

          const toDo = record?.toDo || [];
          const deployed = record?.deployed || [];
          const notApplicable = record?.notApplicable || [];

          return {
            toDo: toDo.length || 0,
            deployed: deployed.length || 0,
            notApplicable: notApplicable.length || 0,
          };
        }),
        catchError(() =>
          of({
            toDo: 0,
            deployed: 0,
            notApplicable: 0,
          }),
        ),
      );
  }

  // =========================================================
  // LOAD TOTAL TASK COUNT
  // =========================================================

  loadTotalapplicableTaskCount(configs: any[]): Observable<any> {
    return forkJoin(
      configs.map((cfg) => this.loadapplicableTaskCount(cfg)),
    ).pipe(
      map((results: any[]) => {
        return results.reduce(
          (acc, item) => {
            acc.toDo += item?.toDo || 0;
            acc.deployed += item?.deployed || 0;
            acc.notApplicable += item?.notApplicable || 0;

            return acc;
          },
          {
            toDo: 0,
            deployed: 0,
            notApplicable: 0,
          },
        );
      }),
    );
  }

  mapConfigValues(values: any[]): any {
    const result: any = {};

    (values || []).forEach((item: any) => {
      // =====================================================
      // NORMAL STRUCTURE
      // =====================================================

      if (item?.Key && item?.Value !== undefined) {
        result[item.Key] = item.Value;
        return;
      }

      // =====================================================
      // NESTED ARRAY STRUCTURE
      // =====================================================

      if (Array.isArray(item)) {
        let key = '';
        let value: any = '';

        item.forEach((subItem: any) => {
          if (subItem?.Key === 'Key') {
            key = subItem?.Value;
          }

          if (subItem?.Key === 'Value') {
            value = subItem?.Value;
          }
        });

        if (key) {
          result[key] = value;
        }
      }
    });

    return result;
  }

  private normalizeTaskMappingEvent(
    event?:
      | string
      | {
          fieldName: string;
          tags: any[];
          selectedQuestion: any;
        },
  ) {
    if (!event) {
      return null;
    }

    if (typeof event === 'string') {
      const field = this.formData?.formFields?.find(
        (f: any) => f.fieldName === event,
      );
      let resolvedQuestion = '';
      if (field) {
        const fieldQuestion =
          field.displayName ||
          field.helpText ||
          field.label ||
          field.fieldName ||
          '';
        resolvedQuestion = fieldQuestion
          .trim()
          .replace(/^\d+\.\s*/, '')
          .replace(/[^a-zA-Z0-9)\]\s]+$/, '');
      }
      return {
        fieldName: event,
        tags: this.getTagsForField(event) || [],
        selectedQuestion: resolvedQuestion,
      };
    }

    let selectedQuestion = event.selectedQuestion;
    if (!selectedQuestion && event.fieldName) {
      const field = this.formData?.formFields?.find(
        (f: any) => f.fieldName === event.fieldName,
      );
      if (field) {
        const fieldQuestion =
          field.displayName ||
          field.helpText ||
          field.label ||
          field.fieldName ||
          '';
        selectedQuestion = fieldQuestion
          .trim()
          .replace(/^\d+\.\s*/, '')
          .replace(/[^a-zA-Z0-9)\]\s]+$/, '');
      }
    }

    return {
      fieldName: event.fieldName,
      tags: Array.isArray(event.tags) ? event.tags : [],
      selectedQuestion: selectedQuestion,
    };
  }

  private normalizeConditionList(conditions: any): any[] {
    if (Array.isArray(conditions)) {
      return conditions;
    }

    return conditions ? [conditions] : [];
  }

  private taskMappingConditionsReferenceField(
    conditions: any[] = [],
    fieldName: string,
  ): boolean {
    return conditions.some((condition: any) => {
      if (condition?.type !== 'field') return false;

      const conditionValue = condition?.value;

      return conditionValue === fieldName;
    });
  }

  private getTaskMappingResponseValues(
    conditions: any[] = [],
    event: ReturnType<FormRenderComponent['normalizeTaskMappingEvent']>,
  ) {
    const tagFieldName = event?.fieldName ? event.fieldName + 'Tags' : null;
    const tagsControl = tagFieldName ? this.saveForm?.get(tagFieldName) : null;
    if (
      tagsControl &&
      Array.isArray(tagsControl.value) &&
      tagsControl.value.length
    ) {
      return tagsControl.value;
    }

    const eventTags = event?.tags?.filter(
      (value: any) => value !== null && value !== undefined && value !== '',
    );

    if (event?.fieldName && eventTags?.length) {
      return eventTags;
    }

    const eventSelectedValues = this.getTaskMappingFieldSelectedValues(
      event?.fieldName,
    );

    if (event?.fieldName && eventSelectedValues.length) {
      return eventSelectedValues;
    }

    return this.getTaskMappingSelectedValues(conditions);
  }

  private getTaskMappingFieldSelectedValues(fieldName?: string): any[] {
    if (!fieldName) {
      return [];
    }

    const fieldValue = this.saveForm?.get(fieldName)?.value;

    if (Array.isArray(fieldValue)) {
      return fieldValue.filter(
        (value: any) => value !== null && value !== undefined && value !== '',
      );
    }

    if (fieldValue !== null && fieldValue !== undefined && fieldValue !== '') {
      return [fieldValue];
    }

    return [];
  }

  getTaskMappingSelectedValues(conditions: any[] = []) {
    return conditions.reduce((selectedValues: any[], condition: any) => {
      if (condition?.type !== 'field' || !condition?.value) {
        return selectedValues;
      }

      // ✅ get TAGS instead of main field
      const tagFieldName = condition.value + 'Tags';
      const fieldValue = this.saveForm?.get(tagFieldName)?.value;

      if (Array.isArray(fieldValue)) {
        return [
          ...selectedValues,
          ...fieldValue.filter(
            (value: any) =>
              value !== null && value !== undefined && value !== '',
          ),
        ];
      }

      if (
        fieldValue !== null &&
        fieldValue !== undefined &&
        fieldValue !== ''
      ) {
        selectedValues.push(fieldValue);
      }

      return selectedValues;
    }, []);
  }

  /**
   * Reloads form data and refreshes integration cards.
   */
  reloadData() {
    if (this.nodeId) {
      const recordId = this.recordID || '0';
      this.loadForm(this.nodeId, recordId);
    }
    this.IntegrationCardsComponent.getData();
  }

  setFirstFocusField() {
    if (!this.formFields?.length) {
      this.firstFocusFieldName = null;
      return;
    }

    const firstField = this.formFields[0];

    this.firstFocusFieldName =
      this.visibleFields[firstField.fieldName] === false
        ? null
        : firstField.fieldName;
  }

  getBadgeStyle(value: string): any {
    const key = value?.toLowerCase()?.trim();

    const color = DARK_COLORS[key] ?? '#94A3B8';

    return {
      backgroundColor: color + '20',
      color: color,
      border: `1px solid ${color}40`,
    };
  }

  registerCustomFieldDependencyWatchers() {
    this.formFields?.forEach((field: any) => {
      if (Array.isArray(field.fieldDependencies)) {
        field.fieldDependencies.forEach((dependency: any) => {
          const triggerFieldName = dependency.trigger;
          if (
            triggerFieldName &&
            triggerFieldName !== 'onValueChange' &&
            triggerFieldName !== 'isTaskMapped'
          ) {
            const triggerControl = this.saveForm.get(triggerFieldName);
            if (triggerControl) {
              triggerControl.valueChanges
                .pipe(takeUntil(this.destroy$))
                .subscribe((selectedValue: any) => {
                  this.executeFieldDependencyActions(dependency, selectedValue);
                });
              // Run initially if it already has a value
              if (triggerControl.value) {
                this.executeFieldDependencyActions(
                  dependency,
                  triggerControl.value,
                );
              }
            }
          }
        });
      }
    });
  }

  executeFieldDependencyActions(dependency: any, selectedValue: any) {
    if (!selectedValue) return;

    const applyActions = (valueObj: any) => {
      const conditionBlocks = Array.isArray(dependency.condition)
        ? dependency.condition
        : Array.isArray(dependency.conditions)
          ? dependency.conditions
          : [];

      conditionBlocks.forEach((condBlock: any) => {
        const conditions = condBlock.conditions || condBlock.condition || [];
        const normalizedConditions = Array.isArray(conditions)
          ? conditions
          : [conditions];

        const isMatched = normalizedConditions.every((cond: any) => {
          if (cond.operator === 'isNotNull') {
            return (
              valueObj !== null && valueObj !== undefined && valueObj !== ''
            );
          }
          return true;
        });

        if (isMatched && Array.isArray(condBlock.actions)) {
          condBlock.actions.forEach((action: any) => {
            const targetField = action.targetField;
            let targetControl =
              this.saveForm.controls[targetField] ||
              this.saveForm.get(targetField);

            if (!targetControl && targetField) {
              const matchKey = Object.keys(this.saveForm.controls || {}).find(
                (k) => k.toLowerCase() === targetField.toLowerCase(),
              );
              if (matchKey) {
                targetControl =
                  this.saveForm.controls[matchKey] ||
                  this.saveForm.get(matchKey);
              }
            }
            if (!targetControl) return;

            if (action.actionType === 'setValueFromSelected') {
              const key = action.value;
              let finalValue = '';
              const isRefreshTokenUrl =
                targetField?.toLowerCase() === 'config.refreshtokenurl' ||
                targetField?.toLowerCase() === 'refreshtokenurl';

              if (typeof key === 'string') {
                let resolvedKey = key;
                if (
                  (resolvedKey === 'authTokenPath' ||
                    resolvedKey === 'AccountsURL' ||
                    (isRefreshTokenUrl && !valueObj[resolvedKey])) &&
                  !valueObj[resolvedKey] &&
                  valueObj['baseTokenPath']
                ) {
                  resolvedKey = 'baseTokenPath';
                }
                if (resolvedKey.includes('{{') && resolvedKey.includes('}}')) {
                  finalValue = resolvedKey.replace(
                    /\{\{([^}]+)\}\}/g,
                    (match, propName) => {
                      let prop = propName;
                      if (
                        (prop === 'authTokenPath' ||
                          prop === 'AccountsURL' ||
                          (isRefreshTokenUrl && !valueObj[prop])) &&
                        !valueObj[prop] &&
                        valueObj['baseTokenPath']
                      ) {
                        prop = 'baseTokenPath';
                      }
                      if (
                        valueObj &&
                        valueObj[prop] !== undefined &&
                        valueObj[prop] !== null &&
                        valueObj[prop] !== ''
                      ) {
                        return valueObj[prop];
                      }
                      const formControlVal =
                        this.saveForm?.get(prop)?.value ||
                        this.saveForm?.get('config.' + prop)?.value ||
                        this.saveForm?.get('config.baseURL')?.value ||
                        this.saveForm?.get('config.baseUrl')?.value ||
                        this.saveForm?.get('config.baseAPIPath')?.value ||
                        this.saveForm?.get('baseURL')?.value ||
                        this.saveForm?.get('baseUrl')?.value ||
                        this.saveForm?.get('baseAPIPath')?.value;
                      if (formControlVal) {
                        return formControlVal;
                      }
                      return match;
                    },
                  );
                } else {
                  if (
                    (resolvedKey === 'authTokenPath' ||
                      resolvedKey === 'AccountsURL' ||
                      resolvedKey === 'baseTokenPath' ||
                      isRefreshTokenUrl) &&
                    !valueObj[resolvedKey] &&
                    valueObj['baseTokenPath']
                  ) {
                    finalValue = valueObj['baseTokenPath'];
                  } else {
                    finalValue =
                      valueObj[resolvedKey] !== undefined &&
                      valueObj[resolvedKey] !== null
                        ? valueObj[resolvedKey]
                        : '';
                  }
                }
              } else {
                finalValue = valueObj;
              }

              if (isRefreshTokenUrl) {
                const tokenBase =
                  valueObj?.['baseTokenPath'] ||
                  valueObj?.['authTokenPath'] ||
                  valueObj?.['AccountsURL'] ||
                  (typeof finalValue === 'string' ? finalValue : '');
                if (typeof tokenBase === 'string' && tokenBase.trim()) {
                  const cleanToken = tokenBase.trim().replace(/\/+$/, '');
                  if (cleanToken.endsWith('/oauth/v2/auth')) {
                    finalValue = cleanToken;
                  } else {
                    finalValue = `${cleanToken}/oauth/v2/auth`;
                  }
                }
              }

              targetControl.setValue(finalValue, { emitEvent: true });
            }
          });
        }
      });
    };

    if (typeof selectedValue === 'object' && selectedValue !== null) {
      applyActions(selectedValue);
      return;
    }

    const triggerField = this.formFields?.find(
      (f: any) => f.fieldName === dependency.trigger,
    );
    const source = triggerField?.options?.source;
    if (source && source.formID && source.apiUrl) {
      const apiEndpoint = this.endpoint;
      const replacements = {
        formId: source.formID,
        formID: source.formID,
        api_endpoint: apiEndpoint,
      };
      const url = this.formService.replaceTemplateTokens(
        source.apiUrl,
        replacements,
      );
      const method = source.method || 'GET';

      this.formService
        .loadData(method, url, { 'Content-Type': 'application/json' }, {}, 30)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            const records = res?.data?.records || [];
            const foundOption = records.find((opt: any) => {
              return (
                opt._id === selectedValue ||
                opt.id === selectedValue ||
                opt.name === selectedValue ||
                opt.text === selectedValue ||
                opt.regionCode === selectedValue ||
                opt.regionName === selectedValue
              );
            });
            if (foundOption) {
              applyActions(foundOption);
            }
          },
          error: (err) =>
            console.error('Error fetching dependency option', err),
        });
    }
  }
}
